<ng-container *ngIf="headerRenderer?.templateRef">
    <ng-container *ngTemplateOutlet="headerRenderer.templateRef;
context:{illustrationUsage:illustrationUsage}"></ng-container>
</ng-container>

<div [style.padding-left]="'1.5rem'" [style.padding-right]="'1.5rem'">
    <div #uploaderContainer class="uploader" [ngClass]="aspectRatio? 'ratio-'+ aspectRatio
                                :illustrationUsage?.nominal_aspect_ratio? 'ratio-custom'
                                : 'ratio-1-1'"
         [style.max-width]="100 * (illustrationUsage?.nominal_aspect_ratio || 1) + '%'"
         [style.padding]="'0'"
         [style.margin]="'auto'"
    >

        <app-uploader
            #uploader
            icon="i-image"
            [preview]="(uploadedFile? uploadedFile.media:null ) | imageFromApi : null"
            [types]="[ 'image/png', 'image/jpg', 'image/jpeg' ]"
            [maxSize]="illustrationUsage?.max_size"
            [minWidth]="illustrationUsage?.min_width"
            [minHeight]="illustrationUsage?.min_height"
            [minAspectRatio]="illustrationUsage?.min_aspect_ratio"
            [maxAspectRatio]="illustrationUsage?.max_aspect_ratio"
            [backgroundSize]="illustrationUsage?.forceRatio?'cover':'contain'"
            [disabled]="disableUpload"
            (fileSelected)="onFileSelected($event)"
            (fileUploaded)="onFileUploaded(illustrationUsage, $event)">
            <ng-template *ngIf="loadingRenderer?.templateRef" appUploaderLoading let-message="message">
                <ng-container *ngTemplateOutlet="loadingRenderer.templateRef; context:{message:message}">
                </ng-container>
            </ng-template>
        </app-uploader>

        <ng-container *ngIf="!uploadedFile">
            <ng-content select="[appUploaderPlaceholder]"></ng-content>
        </ng-container>

        <a *ngIf="enableRemove" (click)="onFileRemoved(uploadedFile)" class="uploader-button-remove">
            <i class="i i-cross-circle"></i>
        </a>
    </div>
</div>

<div class="errors" *ngIf="errorRenderer?.templateRef && selectedFile?.errors">
    <ng-container *ngTemplateOutlet="errorRenderer.templateRef;
    context: {errors:selectedFile?selectedFile.errors:null}">
    </ng-container>
</div>
